export const defaultSystemColor = '#FFFFFF'
